import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { withRouterJim } from "router/withRouterJim";

import NuLoading from 'components/nubox/NuLoading'; 

import pdficon from 'assets/img/pdficon.png';


//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class DebugCompareDB extends React.Component {
  state = {

    isLoading:false,
    
    //id_prod, nombre_p, descrip, preciov1, color
    form: {
      idd:0,
      ope:'n',  
      table_schema: '',
      
    },
    resultado:'',
    
  };
  

  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      //console.log("cheched:"+ e.target.checked);
      let res = e.target.checked? 1:0;
      //console.log("value:"+ res);
      
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //------------------
  btn_click=(e)=>{
    e.preventDefault();
    //href="ttp://localhost:8080/educo/public/api/debug_compare_db_get_db"

    let fileURL = process.env.REACT_APP_API_URL + "debug_compare_db_get_db";
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //-------------------------------------
  save =(e) =>{
    console.log("save")
    e.preventDefault()

      let param = this.state.form
      console.log(param);

      this.setState({ isLoading: true })
      axios2.post( "debug_compare_db_store", param)
      .then(res => {
          console.log("res.data")
          console.log(res.data)
          this.setState({ isLoading: false }) 

          if(res.data.exito === 1){ 
              //toast.success(res.data.men);
              this.setState({ resultado: res.data.cad  });
              
          }else{
              toast.error(res.data.men);
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);  
      });
    
  }
  //-------------------------------------
  render() {

    return (
      <div className="content">
        <ToastContainer />
        <div class="row justify-content-center">

          <div class="col-md-7">

            {
              //JSON.stringify(this.state)
            }

            {/*<!-- /.card -->*/}
            <form id="form01" name="form01" method="post">
              
                <div class="card card-primary">
                  <div class="card-header" 
                      style={{ backgroundColor: '#007bff', color: 'white'}}>
                    <h3 class="card-title">Comprobar base de datos</h3>
                    Copiar el json DB original, esta en este link
                    es el de mi localhost:8080
                    <h4>El esquema externo es el mas completo, copie uno generado en localhost:8080</h4>
                    <button onClick={(e)=> this.btn_click(e) } 
                       className="btn" >
                    link json Localhost</button>
                  </div>
                  {/*<!-- /.card-header -->*/}

                  <div class="card-body">
                    <textarea  
                      rows="4" 
                      cols="50"
                      name="table_schema" 
                      value={this.state.form.table_schema} 
                      onChange={ this.handleChangeForm }></textarea>
                  </div>
                  {/*<!-- /.card-body -->*/}

                  <div class="card-footer text-center">
                    <button class="btn btn-primary" onClick={(e)=> this.save(e) } >Comparar con el server</button>
                  </div>

                  {/*<!-- resultado jquery-->*/}
                  <NuLoading text="Cargando...." show= { this.state.isLoading }/>
                  <div dangerouslySetInnerHTML={{__html: this.state.resultado }}></div>

                </div>

            </form>
          </div>


        </div>

      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(DebugCompareDB);